import styled from "styled-components";

export const EbookSection = styled.section`
  padding: 6rem 2rem;
  background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 20% 80%, rgba(30, 136, 229, 0.05) 0%, transparent 50%),
                radial-gradient(circle at 80% 20%, rgba(255, 193, 7, 0.05) 0%, transparent 50%);
    pointer-events: none;
  }
`;

export const EbookContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;
  position: relative;
  z-index: 1;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 3rem;
    text-align: center;
  }
`;

export const EbookImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  img {
    width: 100%;
    max-width: 400px;
    height: auto;
    border-radius: 20px;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15);
    transition: all 0.3s ease;
    
    &:hover {
      transform: translateY(-10px) scale(1.02);
      box-shadow: 0 30px 60px rgba(0, 0, 0, 0.2);
    }
  }

  &::before {
    content: '';
    position: absolute;
    top: -20px;
    left: -20px;
    right: -20px;
    bottom: -20px;
    background: linear-gradient(135deg, rgba(30, 136, 229, 0.1) 0%, rgba(255, 193, 7, 0.1) 100%);
    border-radius: 30px;
    z-index: -1;
    animation: pulse 3s ease-in-out infinite;
  }

  @keyframes pulse {
    0%, 100% {
      transform: scale(1);
      opacity: 0.7;
    }
    50% {
      transform: scale(1.05);
      opacity: 0.3;
    }
  }
`;

export const EbookTextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const EbookTitle = styled.h2`
  font-size: 3rem;
  font-weight: 900;
  background: linear-gradient(135deg, #1e88e5 0%, #1976d2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 1.5rem;
  text-transform: uppercase;
  letter-spacing: -0.5px;
  line-height: 1.2;

  @media (max-width: 768px) {
    font-size: 2.2rem;
  }
`;

export const EbookSubtitle = styled.h3`
  font-size: 1.5rem;
  font-weight: 700;
  color: #2d3748;
  margin-bottom: 1rem;
  line-height: 1.3;

  @media (max-width: 768px) {
    font-size: 1.3rem;
  }
`;

export const EbookDescription = styled.p`
  font-size: 1.1rem;
  color: #4a5568;
  line-height: 1.7;
  margin-bottom: 1.5rem;
  font-weight: 400;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

export const EbookHighlight = styled.div`
  background: linear-gradient(135deg, #ffc107 0%, #ff9800 100%);
  color: #2d3748;
  padding: 1.5rem;
  border-radius: 15px;
  font-weight: 600;
  font-size: 1.1rem;
  text-align: center;
  box-shadow: 0 8px 25px rgba(255, 193, 7, 0.3);
  margin-bottom: 2rem;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
    transition: left 0.6s ease;
  }

  &:hover::before {
    left: 100%;
  }
`;

export const EbookButton = styled.button`
  background: linear-gradient(135deg, #1e88e5 0%, #1976d2 100%);
  color: white;
  border: none;
  padding: 1.5rem 3rem;
  border-radius: 50px;
  font-weight: 700;
  font-size: 1.2rem;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  text-transform: uppercase;
  letter-spacing: 1px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 8px 25px rgba(30, 136, 229, 0.3);
  align-self: flex-start;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.6s ease;
  }

  &:hover {
    background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
    transform: translateY(-3px) scale(1.05);
    box-shadow: 0 15px 35px rgba(30, 136, 229, 0.4), 0 5px 15px rgba(0, 0, 0, 0.1);

    &::before {
      left: 100%;
    }
  }

  &:active {
    transform: translateY(-1px) scale(1.02);
  }

  @media (max-width: 768px) {
     align-self: center;
     width: 100%;
     max-width: 300px;
   }
`;

export const Container = styled.div`
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
  min-height: calc(100vh - 120px);
`;

export const Header = styled.div`
  text-align: center;
  margin-bottom: 40px;
  padding-bottom: 20px;
  border-bottom: 2px solid #e9ecef;
`;

export const Title = styled.h1`
  color: #007bc6;
  font-size: 2.5rem;
  font-weight: bold;
  margin: 0 0 10px 0;
  
  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const Subtitle = styled.p`
  color: #666;
  font-size: 1.2rem;
  margin: 0;
  
  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  align-items: center;
`;

export const EbookCard = styled.div`
  display: flex;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  max-width: 800px;
  width: 100%;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
  }
  
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const EbookImage = styled.img`
  width: 250px;
  height: 350px;
  object-fit: cover;
  
  @media (max-width: 768px) {
    width: 100%;
    height: 250px;
  }
`;

export const EbookInfo = styled.div`
  padding: 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  
  @media (max-width: 768px) {
    padding: 20px;
  }
`;

export const Features = styled.div`
  margin: 20px 0;
`;

export const Feature = styled.div`
  color: #333;
  font-size: 0.95rem;
  margin: 8px 0;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const PriceSection = styled.div`
  margin: 25px 0;
  padding: 20px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 8px;
  text-align: center;
`;

export const OriginalPrice = styled.div`
  color: #999;
  font-size: 1rem;
  text-decoration: line-through;
  margin-bottom: 5px;
`;

export const CurrentPrice = styled.div`
  color: #28a745;
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 5px;
`;

export const Discount = styled.div`
  background: #dc3545;
  color: white;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: bold;
  display: inline-block;
`;

export const BuyButton = styled.button`
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  border: none;
  padding: 16px 32px;
  border-radius: 8px;
  font-size: 1.2rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: 20px;
  
  &:hover {
    background: linear-gradient(135deg, #20c997 0%, #17a2b8 100%);
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(40, 167, 69, 0.3);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

export const AlreadyPurchased = styled.div`
  background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%);
  color: #155724;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  font-weight: 600;
  margin-top: 20px;
`;

export const AccessButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #007bc6;
  color: white;
  text-decoration: none;
  padding: 10px 20px;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 500;
  margin-top: 15px;
  transition: all 0.3s ease;
  
  &:hover {
    background: #0056b3;
    color: white;
    text-decoration: none;
    transform: translateY(-1px);
  }
`;

export const Testimonials = styled.div`
  max-width: 800px;
  width: 100%;
`;

export const TestimonialsTitle = styled.h3`
  color: #333;
  font-size: 1.5rem;
  font-weight: bold;
  text-align: center;
  margin: 0 0 30px 0;
`;

export const TestimonialCard = styled.div`
  background: white;
  padding: 25px;
  border-radius: 12px;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.08);
  margin-bottom: 20px;
  border-left: 4px solid #007bc6;
`;

export const TestimonialText = styled.p`
  color: #333;
  font-size: 1rem;
  line-height: 1.6;
  margin: 0 0 15px 0;
  font-style: italic;
`;

export const TestimonialAuthor = styled.div`
  color: #007bc6;
  font-weight: 600;
  font-size: 0.9rem;
`;